import { api } from "assets/scripts/utilities/api-clients";

export const index = async (options = {}) => {
  const response = await api.get(`/kam/tax`, options);

  return response;
};
